import React from "react";
import socketio from "socket.io-client";

export const socket = socketio.connect(`https://cho.direct`);
console.log(socket, "socket")
// export const socket = socketio.connect(`http://192.168.0.170:5001`);
// export const socket = socketio.connect(`${process.env.REACT_APP_SOCKET_URL}`);
export const SocketContext = React.createContext();
